import * as React from 'react'

import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/competencies/pages/employees/RootPage'))

const employeesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.employees.id.competencies.path,
      element: <RootPage />,
    },
  ]
}

export default employeesRoutes
